// src/components/QuickExit.jsx
import { useEffect } from 'react';

const EXIT_URL = 'https://www.google.com';

function exit() {
  // location.replace (not href=) so Sauti doesn't sit in forward-history —
  // pressing "back" on the destination site won't return here.
  window.location.replace(EXIT_URL);
}

export default function QuickExit() {
  useEffect(() => {
    // Two taps of Escape is deliberate — a single stray Escape (e.g. closing
    // a dropdown) shouldn't trigger a full site exit.
    let lastEscape = 0;
    function onKey(e) {
      if (e.key !== 'Escape') return;
      const now = Date.now();
      if (now - lastEscape < 600) exit();
      lastEscape = now;
    }
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);

  return (
    <button
      onClick={exit}
      aria-label="Quickly leave this site"
      className="fixed top-3 right-3 z-50 rounded-full bg-ink/90 text-white text-xs font-medium px-3.5 py-2 shadow-lg hover:bg-ink transition-colors backdrop-blur"
      title="Leave this site immediately (or press Escape twice)"
    >
      Quick exit
    </button>
  );
}
